/**
 * Home page behaviour: the Our Cups row's progress line.
 *
 * Ported from components/sections/OurCups.tsx. The thin bar under the track
 * mirrors the track's scroll position (translateX) and the visible fraction
 * (scaleX): start = scrollLeft / scrollWidth, width = clientWidth /
 * scrollWidth, or the full bar when nothing overflows. Synced on scroll and
 * on resize, and again when the theme editor reloads the section.
 */

function bind(section) {
  if (section.dataset.fpBound === '1') return;
  const track = section.querySelector('[data-fp-track]');
  const bar = section.querySelector('[data-fp-bar]');
  if (!track || !bar) return;
  section.dataset.fpBound = '1';

  const sync = () => {
    const max = track.scrollWidth - track.clientWidth;
    const visible = max > 0 ? track.clientWidth / track.scrollWidth : 1;
    const start = max > 0 ? track.scrollLeft / track.scrollWidth : 0;
    bar.style.transform = `translateX(${start * 100}%) scaleX(${visible})`;
  };

  sync();
  track.addEventListener('scroll', sync, { passive: true });
  window.addEventListener('resize', sync);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(sync).catch(() => {});
}

function init(root = document) {
  root.querySelectorAll('[data-our-cups]').forEach(bind);
}

init();
document.addEventListener('shopify:section:load', (e) => init(e.target));
